import { $ } from "@/common/Axios";

export default {
  /**
   * 继教院审批
   */
  approval_audit: {
    /*
     * 审核
     * attach 附件 (string query )
     * classHour 请假课时数，工商大学的必填 (integer query )
     * id id (integer query required)
     * remark 备注 (string query required)
     * status 状态：通过、拒绝 (string query required)
     */
    put: (p, c) => $.put("/api/zms/approval/approval/audit", p, c),
  },
  approval_batchAudit: {
    /*
     * 批量审核
     * attach 附件 (string query )
     * ids id (array query required)
     * remark 备注 (string query required)
     * status 状态：通过、拒绝 (string query required)
     */
    put: (p, c) => $.put("/api/zms/approval/approval/batchAudit", p, c),
  },
  approval_detailsForAttendanceEntrust: {
    /*
     * 委托考勤详情
     * id 审批id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/zms/approval/approval/detailsForAttendanceEntrust", p, c),
  },
  approval_detailsForChangeFocusStatus: {
    /*
     * 修改重点关注详情
     * id 审批id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/zms/approval/approval/detailsForChangeFocusStatus", p, c),
  },
  approval_detailsForHeaderTeacherLeave: {
    /*
     * 班主任请假详情
     * id 审批id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/zms/approval/approval/detailsForHeaderTeacherLeave", p, c),
  },
  approval_detailsForLeave: {
    /*
     * 请假详情
     * id 审批id (integer query required)
     */
    get: (p, c) => $.get("/api/zms/approval/approval/detailsForLeave", p, c),
  },
  approval_detailsForQualityPoint: {
    /*
     * 素质分申请详情
     * id 审批id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/zms/approval/approval/detailsForQualityPoint", p, c),
  },
  approval_listApplyForInner: {
    /*
     * 内部申请的审批流申请列表
     */
    get: (p, c) => $.get("/api/zms/approval/approval/listApplyForInner", p, c),
  },
  approval_listForInner: {
    /*
     * 内部申请的审批流列表
     */
    get: (p, c) => $.get("/api/zms/approval/approval/listForInner", p, c),
  },
  approval_listForStudent: {
    /*
     * 学生申请的审批流列表
     */
    get: (p, c) => $.get("/api/zms/approval/approval/listForStudent", p, c),
  },
  approval_listForStudentByDomain: {
    /*
     * 学生申请的审批流列表
     */
    get: (p, c) =>
      $.get("/api/zms/approval/approval/listForStudentByDomain", p, c),
  },
  approval_withdraw: {
    /*
     * 撤回
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/zms/approval/approval/withdraw", p, c),
  },
  approval_withdrawByStudent: {
    /*
     * 撤回（学生端）
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/zms/approval/approval/withdrawByStudent", p, c),
  },
  approval_withdrawLeaveByHeaderTeacher: {
    /*
     * 撤销学生请假（班主任端）
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/zms/approval/approval/withdrawLeaveByHeaderTeacher", p, c),
  },

  /**
   * 修改重点关注状态
   */
  changeFocusStatus_apply: {
    /*
     * 申请
     * diagnosisInfo 诊断情况概述 (string query )
     * diagnosisProof 诊断证明 (string query )
     * diagnosisStatus 是否有诊断证明 (string query )
     * focusInfo 基本情况概述 (string query )
     * focusStatus 是否重点关注 (string query required)
     * focusType 重点关注类型 (string query )
     * medicalHistory 病史 (string query )
     * medicalHistoryStatus 是否有病史 (string query )
     * promiseLetter 家长承诺书 (string query )
     * promiseStatus 是否有家长承诺书 (string query )
     * schoolRollId 合同id (integer query required)
     */
    post: (p, c) => $.post("/api/zms/approval/changeFocusStatus/apply", p, c),
  },
  changeFocusStatus_listBySchoolRollId: {
    /*
     * 根据合同id获取修改记录
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/zms/approval/changeFocusStatus/listBySchoolRollId", p, c),
  },

  /**
   * 继教院审批流
   */
  flow_list: {
    /*
     * 审批流列表
     * approvalId 审批流id (integer query required)
     */
    get: (p, c) => $.get("/api/zms/approval/flow/list", p, c),
  },

  /**
   * 继教院请假条
   */
  leave_apply: {
    /*
     * 申请
     * attach 附件 (string query required)
     * end 结束时间 (string query required)
     * reason 事由 (string query required)
     * start 开始时间 (string query required)
     * type 类型 (string query required)
     */
    post: (p, c) => $.post("/api/zms/approval/leave/apply", p, c),
  },
  leave_applyForHeaderTeacher: {
    /*
     * 班主任申请请假
     * attach 附件 (string query )
     * end 结束时间 (string query required)
     * reason 事由 (string query required)
     * start 开始时间 (string query required)
     * substituteTeacherId 代班老师id (integer query required)
     * type 类型 (string query required)
     */
    post: (p, c) =>
      $.post("/api/zms/approval/leave/applyForHeaderTeacher", p, c),
  },
  leave_destroy: {
    /*
     * 销假
     * end 结束时间 (string query required)
     * id 请假id (integer query required)
     */
    put: (p, c) => $.put("/api/zms/approval/leave/destroy", p, c),
  },
  leave_listByStudent: {
    /*
     * 学生请假条列表
     */
    get: (p, c) => $.get("/api/zms/approval/leave/listByStudent", p, c),
  },
};
